import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import NavigationBar from './components/NavigationBar'
import Home from './pages/Home';
import TM from './pages/TM';
import GDE from './pages/GDE';
import QC from './pages/QC';
import { useState } from 'react';


const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

const lightTheme = createTheme({
    palette: {
        mode: 'light',
    },
});


function App() {


    const [dark, setDark] = useState(true);
    const toggleTheme = () => {
        setDark(dark ? false : true);
    }

    return (
        <>
            <ThemeProvider theme={dark ? darkTheme : lightTheme}>
                <CssBaseline />
                <BrowserRouter>
                    <NavigationBar darkState={dark} toggleTheme={() => { toggleTheme() }} />
                    <div style={{ marginTop: '75px' }}>
                        <Routes>
                            <Route path="/">
                                <Route path='' element={<Home />} />
                                <Route path='quickchart' element={<QC />} />
                                <Route path='gde' element={<GDE />} />
                                <Route path='tm' element={<TM />} />
                            </Route>
                        </Routes>
                    </div>
                </BrowserRouter>
            </ThemeProvider>
        </>
    );
}

export default App;
